import './unauthenticatedConnectHeader.css';

import React, { useEffect, useState } from 'react';
import { useBuddi } from '@bentley/pw-config';
import { Button } from '@itwin/itwinui-react';
import { useConfigContext } from '../../context';
import { t } from '../../services/translation';
import { AuthenticateRoute } from '../universalLink';

export function UnauthenticatedConnectHeader(): JSX.Element {
  const { config } = useConfigContext();

  const [allowUnauthenticated, setAllowUnauthenticated] = useState(true);

  const connectPortalUrl = useBuddi('ConnectPortalUrl', config.BUDDIRegionCode);

  function setupHeaderFooter(): void {
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any */
    (window as any).GlobalHeaderFooter.setup({
      CustomHeaderOptions: {
        Icon: {
          ImageLocation: window.location.origin + '/Bentley_Logo.png'
        }
      }
    });
  }

  function signIn(): void {
    setAllowUnauthenticated(false);
  }

  useEffect(() => {
    if (!connectPortalUrl) {
      return;
    }

    const headerFooterScript = document.createElement('script');
    headerFooterScript.setAttribute('data-testid', 'header-footer-script');
    headerFooterScript.onload = setupHeaderFooter;
    headerFooterScript.src = `${connectPortalUrl}/Scripts/header-footer-no-auth.js`;

    document.head.appendChild(headerFooterScript);
  }, [connectPortalUrl]);

  if (!allowUnauthenticated) {
    return <AuthenticateRoute route="link" />;
  }

  return (
    <div className="unauthenticated-connect-header">
      <div
        id="GlobalHeader"
        data-testid="UnauthenticatedGlobalHeader"
        className="connect-header"
      />
      <div className="signin-button">
        <Button onClick={signIn}>{t('SignIn.SignIn')}</Button>
      </div>
    </div>
  );
}
